import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/orderAnalysis",
  name: "orderAnalysis",
  redirect: {
    name: "statistic",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/orderAnalysis/analysisList",
      name: "analysisList",
      meta: {
        title: "工单研判列表",
      },
      component: () => import("@/pages/orderAnalysis/analysisList/index.vue"),
    },
    {
      path: "/orderAnalysis/xcxdgd",
      name: "xcxdgd",
      meta: {
        title: "现场协调工单列表",
      },
      component: () => import("@/pages/orderAnalysis/order1/index.vue"),
    },
    {
      path: "/orderAnalysis/bljhgd",
      name: "bljhgd",
      meta: {
        title: "办理较好工单",
      },
      component: () => import("@/pages/orderAnalysis/order2/index.vue"),
    },
    {
      path: "/orderAnalysis/xxdxypjsxgd",
      name: "xxdxypjsxgd",
      meta: {
        title: "协作事项工单",
      },
      component: () => import("@/pages/orderAnalysis/order3/index.vue"),
    },
    {
      path: "/orderAnalysis/yjsxgd",
      name: "yjsxgd",
      meta: {
        title: "预警事项工单",
      },
      component: () => import("@/pages/orderAnalysis/order4/index.vue"),
    },
    {
      path: "/orderAnalysis/zzzxxbgd",
      name: "zzzxxbgd",
      meta: {
        title: "六方联办工单",
      },
      component: () => import("@/pages/orderAnalysis/order5/index.vue"),
    },
    {
      path: "/orderAnalysis/gzdbgd",
      name: "gzdbgd",
      meta: {
        title: "跟踪督办工单",
      },
      component: () => import("@/pages/orderAnalysis/order6/index.vue"),
    },
    {
      path: "/orderAnalysis/xldddgd",
      name: "xldddgd",
      meta: {
        title: "报请领导批示调度工单",
      },
      component: () => import("@/pages/orderAnalysis/order7/index.vue"),
    },
    {
      path: "/orderAnalysis/xxafdygd",
      name: "xxafdygd",
      meta: {
        title: "实地踏看工单",
      },
      component: () => import("@/pages/orderAnalysis/order8/index.vue"),
    },
    {
      path: "/orderAnalysis/sfjzhypgd",
      name: "sfjzhypgd",
      meta: {
        title: "需列入下次编办、司法局综合研判工单",
      },
      component: () => import("@/pages/orderAnalysis/order9/index.vue"),
    },
    {
      path: "/orderAnalysis/xjrdmygd",
      name: "xjrdmygd",
      meta: {
        title: "县级认定满意工单",
      },
      component: () => import("@/pages/orderAnalysis/order10/index.vue"),
    },
    {
      path: "/orderAnalysis/21jqzsbmsssgd",
      name: "21jqzsbmsssgd",
      meta: {
        title: "21件群众身边民生实事工单",
      },
      component: () => import("@/pages/orderAnalysis/order11/index.vue"),
    },
    {
      path: "/orderAnalysis/jsjbfxyp",
      name: "jsjbfxyp",
      meta: {
        title: "接诉即办+分析研判",
      },
      component: () => import("@/pages/orderAnalysis/order12/index.vue"),
    },
    {
      path: "/orderAnalysis/jsjbrmjyzj",
      name: "jsjbrmjyzj",
      meta: {
        title: "接诉即办+人民建议征集",
      },
      component: () => import("@/pages/orderAnalysis/order13/index.vue"),
    },
    {
      path: "/orderAnalysis/jsjbwgfwgl",
      name: "jsjbwgfwgl",
      meta: {
        title: "接诉即办+网格服务管理",
      },
      component: () => import("@/pages/orderAnalysis/order14/index.vue"),
    },
  ],
};
